// @generated by protoc-gen-es v1.2.0 with parameter "target=js+dts"
// @generated from file wavin/aqora/v2/product_mutation.proto (package wavin.aqora.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import {proto3} from "@bufbuild/protobuf";
import {CreateProductType} from "./system_pb.js";
import {TranslatableError} from "./system_mutation_pb.js";

/**
 * @generated from message wavin.aqora.v2.DeleteProductRequest
 */
export const DeleteProductRequest = proto3.makeMessageType(
  "wavin.aqora.v2.DeleteProductRequest",
  () => [
    {no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */},
  ],
);

/**
 * @generated from message wavin.aqora.v2.DeleteProductResponse
 */
export const DeleteProductResponse = proto3.makeMessageType(
  "wavin.aqora.v2.DeleteProductResponse",
  [],
);

/**
 * @generated from message wavin.aqora.v2.CreateProductRequest
 */
export const CreateProductRequest = proto3.makeMessageType(
  "wavin.aqora.v2.CreateProductRequest",
  () => [
    {no: 1, name: "reservoir_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "drain_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 4, name: "system_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 3, name: "type", kind: "enum", T: proto3.getEnumType(CreateProductType)},
  ],
);

/**
 * @generated from message wavin.aqora.v2.UpdateProductRequest
 */
export const UpdateProductRequest = proto3.makeMessageType(
  "wavin.aqora.v2.UpdateProductRequest",
  () => [
    {no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */},
  ],
);

/**
 * @generated from message wavin.aqora.v2.ProductResponse
 */
export const ProductResponse = proto3.makeMessageType(
  "wavin.aqora.v2.ProductResponse",
  () => [
    {no: 1, name: "success", kind: "message", T: ProductResponse_Success, oneof: "outcome"},
    {no: 2, name: "failure", kind: "message", T: ProductResponse_Failure, oneof: "outcome"},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.ProductResponse.Field
 */
export const ProductResponse_Field = proto3.makeEnum(
  "wavin.aqora.v2.ProductResponse.Field",
  [
    {no: 0, name: "FIELD_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "FIELD_NAME", localName: "NAME"},
    {no: 2, name: "FIELD_RESERVOIR_NAME", localName: "RESERVOIR_NAME"},
    {no: 3, name: "FIELD_DRAIN_NAME", localName: "DRAIN_NAME"},
    {no: 4, name: "FIELD_TYPE", localName: "TYPE"},
    {no: 5, name: "FIELD_TITLE", localName: "TITLE"},
    {no: 6, name: "FIELD_SYSTEM_NAME", localName: "SYSTEM_NAME"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.ProductResponse.Success
 */
export const ProductResponse_Success = proto3.makeMessageType(
  "wavin.aqora.v2.ProductResponse.Success",
  () => [
    {no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */},
  ],
  {localName: "ProductResponse_Success"},
);

/**
 * @generated from message wavin.aqora.v2.ProductResponse.FieldError
 */
export const ProductResponse_FieldError = proto3.makeMessageType(
  "wavin.aqora.v2.ProductResponse.FieldError",
  () => [
    {no: 1, name: "field", kind: "enum", T: proto3.getEnumType(ProductResponse_Field)},
    {no: 2, name: "error", kind: "message", T: TranslatableError},
  ],
  {localName: "ProductResponse_FieldError"},
);

/**
 * @generated from message wavin.aqora.v2.ProductResponse.Failure
 */
export const ProductResponse_Failure = proto3.makeMessageType(
  "wavin.aqora.v2.ProductResponse.Failure",
  () => [
    {no: 1, name: "errors", kind: "message", T: TranslatableError, repeated: true},
    {no: 2, name: "field_errors", kind: "message", T: ProductResponse_FieldError, repeated: true},
  ],
  {localName: "ProductResponse_Failure"},
);

/**
 * @generated from message wavin.aqora.v2.LinkProductRequest
 */
export const LinkProductRequest = proto3.makeMessageType(
  "wavin.aqora.v2.LinkProductRequest",
  () => [
    {no: 1, name: "product_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "device_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
  ],
);

/**
 * @generated from message wavin.aqora.v2.LinkProductResponse
 */
export const LinkProductResponse = proto3.makeMessageType(
  "wavin.aqora.v2.LinkProductResponse",
  [],
);

/**
 * @generated from message wavin.aqora.v2.UnlinkProductRequest
 */
export const UnlinkProductRequest = proto3.makeMessageType(
  "wavin.aqora.v2.UnlinkProductRequest",
  () => [
    {no: 1, name: "product_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
  ],
);

/**
 * @generated from message wavin.aqora.v2.UnlinkProductResponse
 */
export const UnlinkProductResponse = proto3.makeMessageType(
  "wavin.aqora.v2.UnlinkProductResponse",
  [],
);

